import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Log} from "ng2-logger";
import {ToolFormModel} from "@app/tool/tool-form-modal/tool-create.model";
import {MaintenancePlan} from "@models/maintenancePlan.model";
import {MaintenancePlansService} from "@app/maintenance/service/maintenance-plans.service";
import {TableConfig} from "@app/shared/util/table-config.utils";
import {ToolService} from "@services/tool.service";
import {ToastsManager} from "@app/shared/util/toastr.service";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, FormGroup} from "@angular/forms";


@Component({
    selector: 'app-tool-maintenance-plan',
    templateUrl: './tool-maintenance-plan.component.html',
    styleUrls: ['./tool-maintenance-plan.component.scss']
})
export class ToolMaintenancePlanComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolMaintenancePlanComponent.name);

    @Input() tool?: ToolFormModel;

    planForm: FormGroup;
    plans: MaintenancePlan[];

    constructor(private maintenancePlansService: MaintenancePlansService,
                private toolService: ToolService,
                private translationService: TranslateService,
                private toastr: ToastsManager) {
    }

    ngOnInit() {
        this._logger.info('ngOnInit::', this.tool);
        this.planForm = new FormGroup({
            plan: new FormControl(null),
        });

        this.getMaintenancePlans();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tool && changes.tool?.currentValue?.maintenancePlanId !==
            changes.tool?.previousValue?.maintenancePlanId) {
            this.selectPlan();
        }
    }

    private getMaintenancePlans() {
        const tableConfig = new TableConfig();
        tableConfig.pager.pageSize = -1;

        this.maintenancePlansService.getPlans(tableConfig).subscribe((data: any) => {
            this.plans = data.items;
            this.selectPlan();
        });
    }

    onSelectPlan(event: any) {
        if (!this.tool || !this.tool.id || this.tool.maintenancePlanId === event.id) {
            return;
        }

        this.toolService.updateTool({id: this.tool.id, maintenancePlanId: event.id})
            .subscribe((data) => {
                this.toastr.success(this.translationService.instant('admin.tools.form.notifications.maintenancePlanAssigned.success'));
                this.tool.maintenancePlanId = data.maintenancePlanId;

                this._logger.info('onSelectPlan:: API returned data', data);
            }, (error) => {
                this.toastr.error(this.translationService.instant('admin.tools.form.notifications.maintenancePlanAssigned.error'));
                this._logger.error('onSelectPlan:: API returned error', error);
            });
    }

    selectPlan() {
        if (!this.plans || this.plans.length === 0) {
            return;
        }

        if (!this.tool || !this.tool.maintenancePlanId) {
            return;
        }

        const selectedPlan = this.plans.find(item => item.id === this.tool.maintenancePlanId)
        if (selectedPlan) {
            this.planForm.controls.plan.setValue(selectedPlan);
        }
    }
}
